import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';

export interface PageRequest {
  page: number;
  limit: number;
  offset: number;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input('data') data;
  @Input('itemsPerPage') itemsPerPageValue = 10;

  /**
   * Liczba WSZYSTKICH wierszy po stronie serwera. Podanie jej przełącza komponent
   * w tryb serwerowy: `data` jest wtedy już gotową stroną, więc nic nie tniemy —
   * zamiast tego prosimy rodzica o kolejną paczkę przez (pageChange).
   * Bez tego wejścia komponent zachowuje się dokładnie jak dotąd.
   */
  @Input() total: number = null;

  /**
   * Zmiana tej wartości cofa paginację na pierwszą stronę. Potrzebne w trybie
   * serwerowym po zmianie filtra: `data` zmienia się przy każdej stronie, więc nie
   * może służyć za sygnał, a `total` po przefiltrowaniu bywa przypadkiem taki sam.
   */
  @Input() resetToken: any = null;

  @Output() outputData: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() pageChange: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  public itemsPerPage: number;
  public totalItems: any;
  public page: any;
  public previousPage: any;
  private paginatedData: any;
  public innerWidth: any;

  constructor() { }

  get serverSide(): boolean {
    return this.total !== null && this.total !== undefined;
  }

  ngOnInit() {
    this.itemsPerPage = this.itemsPerPageValue;
    this.page = 1;
    this.innerWidth = window.innerWidth;

    if (this.serverSide) {
      // Pierwszą stronę rodzic pobrał sam — emisja tutaj wywołałaby drugie żądanie.
      this.totalItems = this.total;
      return;
    }

    this.totalItems = this.data.length;
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.serverSide) {
      // W trybie serwerowym `data` zmienia się przy KAŻDYM przewróceniu strony,
      // więc reset na jej zmianie zapętliłby pobieranie. Numer strony cofamy tylko,
      // gdy zmieni się liczba wszystkich wierszy — czyli po zmianie filtra.
      if (changes['total'] && !changes['total'].firstChange) {
        this.totalItems = this.total;
        if (changes['total'].previousValue !== changes['total'].currentValue) {
          this.page = 1;
          this.previousPage = 1;
        }
      }
      if (changes['resetToken'] && !changes['resetToken'].firstChange) {
        this.page = 1;
        this.previousPage = 1;
      }
      return;
    }

    if (changes['data'] && !changes['data'].firstChange) {
      this.page = 1;
      this.totalItems = this.data.length;
      this.loadData();
    }
  }

  public loadPage(page: number): void {
    if (page === this.previousPage) {
      return;
    }
    this.previousPage = page;

    if (this.serverSide) {
      this.pageChange.emit({
        page,
        limit: this.itemsPerPage,
        offset: (page - 1) * this.itemsPerPage
      });
      return;
    }

    this.loadData();
  }

  private loadData(): void {
    this.paginatedData = this.data.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
    this.outputData.emit(this.paginatedData);
  }

  get showPagination(): boolean {
    return this.totalItems > this.itemsPerPage;
  }

}
